// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2pYJs","itemTitle":"ClientEmergencyInfo_itemTitle__1uI2s","itemText":"ClientEmergencyInfo_itemText__1SuBO"};